(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accodian"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.mng-accordion-item');

    items.forEach(item => {
      const answer = item.querySelector('.mng-accordion-answer');
      if (item.classList.contains('mng-accordion-active')) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });

    items.forEach(item => {
      const question = item.querySelector('.mng-accordion-question');
      const answer = item.querySelector('.mng-accordion-answer');

      question.addEventListener('click', () => {
        const isActive = item.classList.contains('mng-accordion-active');


        items.forEach(i => {
          const a = i.querySelector('.mng-accordion-answer');
          if (i !== item) {
            i.classList.remove('mng-accordion-active');
            a.style.maxHeight = null;
          }
        });


        if (isActive) {
          item.classList.remove('mng-accordion-active');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('mng-accordion-active');
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certificates"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.querySelector('.mng-essentials-section-{{ section.id }}');
  if (root) {
    root.style.setProperty('--marquee-speed', '{{ section.settings.marquee_speed }}s');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sliderWrapper = document.querySelector('.fuel-slides-wrapper');
  const slides = document.querySelectorAll('.fuel-slide-uniq');
  const dotsContainer = document.querySelector('.slider-dots');

  let currentIndex = 0;
  const totalSlides = slides.length;

  // Create dots dynamically
  slides.forEach((_, index) => {
    const dot = document.createElement("button");
    if (index === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      currentIndex = index;
      updateSliderPosition();
      updateDots();
    });
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll("button");

  function updateSliderPosition() {
    sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  function updateDots() {
    dots.forEach(dot => dot.classList.remove("active"));
    dots[currentIndex].classList.add("active");
  }

  function goToNext() {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSliderPosition();
    updateDots();
  }

  function goToPrev() {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSliderPosition();
    updateDots();
  }

  // Auto-slide every 6 seconds
  let autoSlide = setInterval(goToNext, 6000);

  // --- TOUCH SWIPE HANDLING ---
  let startX = 0;
  let endX = 0;

  sliderWrapper.addEventListener("touchstart", (e) => {
    clearInterval(autoSlide); // stop auto while swiping
    startX = e.touches[0].clientX;
  });

  sliderWrapper.addEventListener("touchmove", (e) => {
    endX = e.touches[0].clientX;
  });

  sliderWrapper.addEventListener("touchend", () => {
    let diff = startX - endX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        goToNext(); // swipe left → next
      } else {
        goToPrev(); // swipe right → prev
      }
    }
    autoSlide = setInterval(goToNext, 6000); // restart auto
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');    
  });

  jQuery(document).ready(function($) {  
   "use strict";    
     
       if($(window).width() <= 991) { 
      
      $("nav.vertical-mega-menu").each(function() {
  
        var vdata = $(this).data('vmenu'),                    
            ulData = $(this).find('ul[data-vmenu="' + vdata + '"]').clone().removeClass('dt-vnav'),
            vmobileData = $('body').find('.mobile-vmenu[data-vmenu="' + vdata + '"]');        

        console.log(ulData);
        // To Remove animation classes
        $('[data-animation]', ulData).each(function(ix, ele) {
          var $classes = $(ele).attr("class"),
              $animation = $(ele).attr("data-animation");
          $classes = $classes.replace($animation, '');
          $(ele).attr("class", $classes);
        });  
        ulData.prependTo(vmobileData);
      });
  
      VmobileTrigger();
  
      // Closing Mobile Nav
      $('li.v-close-nav').on('click', function(event) {
        VcloseMobNav();
      });
  
      $('body .vertical-mobile-menu-overlay').on('click', function(event) {
        VcloseMobNav();
      });
  
      // Sub Menu in Mobile Menu
      $('.v-mega-has-children > a').on('click', function(event) {
  
        if ($('body').hasClass('vnav-is-visible')) {
          event.preventDefault();
          var a = $(this).clone();
          $(this).next('.v-menu-sub').find('.see-all').html(a);          
        }
  
        var selected = $(this);                
        if (selected.next('div.v-menu-sub').hasClass('is-v-hidden')) {                    
          selected.addClass('selected').next('div.v-menu-sub').removeClass('is-v-hidden');
        } else {          
          selected.removeClass('selected').next('div.v-menu-sub').addClass('is-v-hidden');
        }
      });
  
      // Go Back in Mobile Menu
      $('.go-back').on('click', function() {        
        $(this).closest('div.v-menu-sub').addClass('is-v-hidden');
      });
    }
  

   function VmobileTrigger(){
      $('.vmenu-trigger').on('click', function(event) {    
        $('body').find('.mobile-vmenu').addClass('vnav-is-visible');
        $('body').find('.mobile-menu-overlay').addClass('is-showit');
        $('body').addClass('vnav-is-visible');        
      });  
    }
  
    function VcloseMobNav() {
      $('body').removeClass('vnav-is-visible');
      $('.vertical-mobile-menu-overlay').removeClass('is-showit');
      $('.mobile-vmenu').removeClass('vnav-is-visible');
      $('.v-mega-has-children a').removeClass('selected');
      $('.v-mega-has-children div.v-menu-sub').addClass('is-v-hidden');
    }
  
    $(window).on('resize',function() {
      VmobileTrigger();
      VcloseMobNav();          
    });
  
    $(window).on('load',function() {     
      VmobileTrigger();
      VcloseMobNav();  
    });

/* Tabs on Vertical navigation  */
    
 $(function() {
      if($(window).width() >= 992) {
         $('.from-vertical .tabs-nav a').click(function() {
         $(this).removeClass('active');
        $(this).parent().addClass('active');  
        let currentTab = $(this).attr('href');        
        $('.v-menu-sub .tabs-content li.dt-sc-menu-tabs').hide();
       console.log(currentTab);
        $(currentTab).show();
        return false;
      });
    }
      if($(window).width() < 992 ) { 
      $('.from-vertical .mobileTabs .tabs  li').each(function(){
        $(this).click(function(){        
          $(this).next('div').slideToggle(0);        
        });  
      })  
    }
    });    
});
  


  
  $('.level-has-child li.leavel-has-dropdown').click(function () {  
          $('li.leavel-has-dropdown').not(this).find('ul').hide();  
          $(this).find('ul').toggle();  
      });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-indi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMind360Sliders(root) {
      if (typeof Swiper === 'undefined') return;

      root.querySelectorAll('.mind360-carousel').forEach(function (slider) {
        if (slider.swiper) return;

        new Swiper(slider, {
          slidesPerView: 1.2,
          spaceBetween: 20,
          allowTouchMove: true,
          watchOverflow: true,
          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initMind360Sliders(document);
      });
    } else {
      initMind360Sliders(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initMind360Sliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
